<template>
  <div>
    <canvas v-if="url" :style="{width: '100%', height:height}" :id="videoID"></canvas>
    <div v-if="!url" :style="{height: height}">
      <el-empty :image-size="80" description="无视频接入"></el-empty>
    </div>
  </div>
</template>

<script>
  import {guid} from "../util/string.util"
  export default {
    props: {
      url: {
        type: String,
        default: '',
      },
      startToPlay: {
        type: Boolean,
        default: false,
      },
      height: {
        type: String,
        default: '200px',
      }
    },
    data() {
      return {
        videoID: "",
        player: null,
      };
    },
    watch: {
      url(val) {
        this.$nextTick(() => {
          if (this.url) {
            this.startPlay(this.url);
          }
        });
      }
    },
    created(){
      this.videoID = "vid" + guid().substring(0, 20);
    },
    mounted() {
      this.$nextTick(() => {
        if (this.url) {
          this.startPlay(this.url);
        }
      });
    },
    methods: {
      startPlay(url) {
        let $this = this;
        var canvas = document.getElementById(this.videoID);
        $this.player = new JSMpeg.Player(url, {canvas: canvas});
      }
    },
    destroyed() {
        this.player = null;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/video/Rtsp2WsVideo.vue